import Box from '@mui/material/Box';
import VideoLogo from '../VideoLogo';
import Typography from '@mui/material/Typography';
import React from 'react';

const Header = ({ logoPath, fallbackLogoUrl, accountName }) => {
  return (
    <header>
      <Box display="flex" justifyContent="center" mb={2}>
        {logoPath ? (
          <VideoLogo location={logoPath} />
        ) : (
          <div>
            {fallbackLogoUrl ? (
              <img className="logo" src={fallbackLogoUrl} />
            ) : (
              <Typography variant="subtitle1" fontWeight={600}>
                {accountName}
              </Typography>
            )}
          </div>
        )}
      </Box>
    </header>
  );
};

export default Header;
